module.exports = __webpack_public_path__ + "static/media/HCMM357.bbcbee30.jpg";